import { selectWarehouse } from 'containers/Warehouses/warehousesSlice'
import DeliveryPopup from 'components/popups/DeliveryPopup'
import { Action/* , getTotalDeposits */ } from '../core/utils'
import { useHistory, useParams } from 'react-router-dom'
import { SECTION_TYPES } from 'containers/Warehouse'
import ArrowBtn from 'components/buttons/ArrowBtn'
import { LOCATION_STATES } from 'utils/constants'
import useTranslation from 'hooks/useTranslation'
import BackBtn from 'components/buttons/BackBtn'
import usePopupState from 'hooks/usePopupState'
import { displayPrice } from 'utils/string'
import Input from 'components/inputs/Input'
import ReasonSelect from './ReasonSelect'
import { useReduxSelector } from 'store'
import Deposits from '../core/Deposits'
import Option from 'components/Option'
import React from 'react'

interface DefaultProps {
  isSending: boolean
  response?: payments.Quote
  selectedData: payments.SelectedData
  deliveries: payments.Delivery[]
  sendResignation: basic.BasicFunc
  selectData: React.Dispatch<React.SetStateAction<payments.SelectedData>>
  setDeliveries: React.Dispatch<React.SetStateAction<payments.Delivery[]>>
}

const type = process.env.REACT_APP_TYPE

const Default: React.FC<DefaultProps> = ({ isSending, response, selectedData, deliveries, selectData, setDeliveries, sendResignation }) => {
  const { id } = useParams<warehouse.PageParams>()
  const warehouse = useReduxSelector(state => selectWarehouse(state, id))
  const { popup } = usePopupState()

  const { push, goBack } = useHistory()
  const { t } = useTranslation('warehouse')
  const openAction = (action: Action) => {
    push(`/warehouses/${id}/${SECTION_TYPES.cancel}/${action}`)
  }

  // const grossPrice = Number(response?.warehouses?.[0]?.grossAmount)
  // const deposit = getTotalDeposits(selectedData, response?.warehouses?.[0])
  const photosLength = selectedData.photos?.length || selectedData.documents?.length || 0
  const photosAdded = (selectedData.photos && selectedData.photos.length > 0) || (selectedData.documents && selectedData.documents.length > 0)
  const itemsToReturn = response?.flags?.itemsToReturn && response?.flags?.itemsToReturn.length > 0
    ? response?.flags?.itemsToReturn?.map((item) => {
      const { id, name, deposit } = item
      const deliveryId = selectedData.itemsToReturn?.[id]
      return <Option
        key={id}
        dashedBorder
        secondaryTheme
        selected={!deliveryId}
        title={`${t('return')} ${name}`}
        buttonText={t(deliveryId ? 'change' : 'return')}
        desc={`${t('depositCollected')}: ${displayPrice(deposit)}`}
        action={() => {
          push(window.location.pathname, LOCATION_STATES.popup({ type: 'returns', data: item } as unknown as string))
        }}
      />
    })
    : undefined

  return <>
    {(popup as any)?.type === 'returns' && <div>
      {((data: payments.CancelRentalResponseWarehouseReturn) => {
        return <DeliveryPopup
          popupName={t('returns')}
          price={data.deposit}
          cancelAction={goBack}
          productName={data.name}
          deliveryMethods={data.returnMethods}
          recentlySelectedDeliveries={deliveries}
          setRecentlySelectedDeliveries={setDeliveries}
          callback={({ deliveryId }) => {
            if (deliveryId) {
              selectData(prev => ({ ...prev, itemsToReturn: { ...(prev.itemsToReturn || {}), [data.id]: deliveryId } }))
            }
            goBack()
          }}
        />
      })((popup as any).data)}
    </div>}

    <div className='title'>
      <div>{t('resignationType.cancel')}</div>
    </div>

    <div className='resignation__main'>
      <div className='resignation__steps'>
        <div className='resignation__info'>{t('agreementWillBeTerminatedImmediately')}</div>
        <ReasonSelect
          disabled={isSending}
          selectedData={selectedData}
          selectData={selectData}
        />

        <Input
          name='refundName'
          label={t('recipientName')}
          placeholder={t('enterTheRecipientName')}
          value={selectedData.refundName || ''}
          changeHandler={e => {
            selectData(prev => ({ ...prev, refundName: e.target.value }))
          }}
        />

        <Input
          name='refundAccountNumber'
          label={t('bankAccountNumber')}
          placeholder={t('enterYourBankAccountNumber')}
          value={selectedData.refundAccountNumber || ''}
          changeHandler={e => {
            selectData(prev => ({ ...prev, refundAccountNumber: e.target.value }))
          }}
        />

        {response?.flags?.needPhoto && <Option
          selected
          secondarySelectionColor={photosAdded}
          title={t(`takeAPictureOfTheMAGIfYouOpenedIt.${type}`)}
          desc={photosAdded
            ? photosLength === 1
              ? `${t('added')} ${t('onePhoto')}`
              : `${t('added')} ${photosLength} ${t('photos')}`
            : t(`showTheStatusOfYourMag.${type}`)}
          buttonText={t(photosAdded ? 'change' : 'add')}
          icon='add-photo'
          action={() => {
            openAction('camera')
          }}
        />}

        {/* <div className='title'>
          <div>{t('requiredActions')}</div>
          <div>{t('youMustCompleteTheseToCompleteTheRental')}</div>
        </div>

        <Option
          selected
          secondary={!deposit && grossPrice >= 0}
          title={t('payments')}
          buttonText={t('goTo')}
          desc={
            deposit > 0 || grossPrice < 0
              ? `${t('toBeReturned')} ${displayPrice(deposit + (grossPrice < 0 ? (grossPrice * -1) : 0))}`
              : t('everythingsAllRight')
          }
          icon='payments'
          action={() => {
            if (deposit) {
              openAction('summary')
            }
          }}
        /> */}

        {itemsToReturn
          ? <>
            <p className='--center'>{t('chooseHowToReturnYourItems')}</p>
            {itemsToReturn}
          </>
          : null}

        <Deposits
          deposits={response?.deposits}
          depositsSummary={response?.depositsSummary}
        />
      </div>

      <div className='resignation__buttons'>
        <ArrowBtn
          enlarged
          text={t('confirm')}
          isLoading={isSending}
          action={sendResignation}
        />
        {(!warehouse.resignation || warehouse.resignation.canStop) && <BackBtn />}
      </div>
    </div>
  </>
}

export default Default